import { Button, CardContent, Drawer, ListItem } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import CustomDataGrid from '../DataGrid/DataGrid';
import Filters from '../Filters/Filters';
import CustomizedEstimateMenus from '../dropdownbutton/estimateActionMenu';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { PermissionsEnum } from "../../utils/auth.types";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Link from '@mui/material/Link';
import { ApiStatus } from "../../utils/api.types";
import { Utils } from "../../utils/common-utils";
import { GridActionsCellItem, GridColDef, GridColumnHeaderParams, GridValueGetterParams } from '@mui/x-data-grid';
import { AInvoice } from '../../utils/invoice.types';
import { AEstimate } from '../../utils/estimate.types';
import { fetchEstimates } from '../../store/estimateStore/estimateThunk';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
// import DialogPaymentSettlementForm from '../DialogPaymentSettlementForm/DialogPaymentSettlementForm';
import DialogRecievePaymentForm from '../DialogPaymentSettlementForm/DialogRecievePaymentForm';
import DialogInvoiceReciepts from '../DialogInvoiceReciepts/DialogInvoiceReciepts';
import Invoice from '../Invoice/Invoice';
import EstimateForm from '../../pages/Estimate/EstimateForm';


interface EstimateFlowDetails {
    accountType: string;
    estimateId?: string;
    type: string;
}
const CashFlowData: FC<EstimateFlowDetails> = (props) => {
    const dispatch = useAppDispatch();

    // const { invoices, status } = useAppSelector(state => state.invoices);
    const { estimates, status } = useAppSelector(state => state.estimates);
    const { permissions, selectedAccount } = useAppSelector(state => state.auth);
    const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);

    const navigate = useNavigate();
    const currentPathName = window.location.href;
    const curPage = currentPathName.split('/');
    const [showPaymentButton, setShowPaymentButton] = useState<Boolean>(false);
    const [openSettlementDrawer, setOpenSettlementDrawer] = useState<boolean>(false);
    const [openRecivePaymentDrawer, setOpenRecivePaymentDrawer] = useState<boolean>(false);
    const [openInvoiceRecieptsDrawer, setOpenInvoiceRecieptsDrawer] = useState<boolean>(false);
    const [selectedBuyerId, setSelectedBuyerId] = useState('');
    const [selectedInvoices, setSelectedInvoices] = useState<AEstimate[]>([]);
    const [filters, setFilters] = useState('');
    const [isRefersh, setIsRefersh] = useState(false);

    // Handle estimate button
    const handleAddEstimate = () => {
        const navLink = `/sales/estimate/create`;
        navigate(navLink);
    };

    /**
    * Handler for account name click.
    */
    const handleInvoiceNoClick = useCallback(({ _id, status, pdfTemplate }: AEstimate) => {
        //Call edit function
        let navLink = '';
        let type = '';
        if (curPage.includes('account-payable')) {
            type = 'AP';
        } else {
            type = 'AR';
        }
        if (status === 'DRAFT') {
            navLink = curPage.includes('account-payable') ? `/account-payable/invoice/edit/${_id}` : `/account-receivable/invoice/edit/${_id}`;
        } else {
            navLink = `/invoice/${_id}/view?templateId=${pdfTemplate}&type=${type}`;
        }
        navigate(navLink);
    }, []);


    const handleInvoicePaymentReceiptClick = useCallback(({ _id, status, pdfTemplate }: AEstimate) => {
        let navLink = '';
        let type = '';
        if (curPage.includes('account-payable')) {
            type = 'AP';
        } else {
            type = 'AR';
        }

        navLink = `/invoice-payment-receipt/${_id}/view?templateId=${pdfTemplate}&type=${type}`;
        navigate(navLink);
    }, []);

    const navigateToEdit = (_id: any) => {
        let navLink = `/account-payable/invoice/edit/${_id}`;
        navigate(navLink);
    };

    const handleSettleInvoice = (event: any) => {
        setOpenSettlementDrawer(true);
        event.stopPropagation();
    };

    const handleRecievePayment = (event: any) => {
        setOpenRecivePaymentDrawer(true);
        event.stopPropagation();
    }

    const handleClose = () => {
        // setSelectedInvoices([]);
        setOpenSettlementDrawer(false);
    };

    const openDrawer = (e: any, id: any) => {
        // onRowsSelectionHandler([id]);
        // setSelectedInvoices([id]);
        handleSettleInvoice(e);
    };

    const openDrawer2 = (e: any, id: any) => {
        console.log(props.estimateId);
        console.log("setting client invoices in main drawer 2 called ---------")
        console.log(id);
        console.log(id.buyer._id);
        setSelectedBuyerId(id.buyer._id);

        console.log(selectedInvoices);
        handleRecievePayment(e);
    };

    const openCreateEstimateDrawer = (event: any) => {
        setOpenRecivePaymentDrawer(true);
        event.stopPropagation();
    }

    const handleCloseCreateEstimateDrawer = () => {
        // setSelectedInvoices([]);
        setOpenRecivePaymentDrawer(false);
    };


    const filterOnChangeHandler = (data: any) => {
        setFilters(data);
    };

    const TabHeading = (props.accountType == "Invoices") ? "" : `${props.accountType} Cash Summary`;

    /**
      * Fetch all the accounts on Accounts page load.
      */
    useEffect(() => {
        // setSelectedInvoices([]);
        console.log("Called useEffect 111111 ------ >>>>> ");
        if (filters) {
            const { _id: id } = selectedAccount;
            dispatch(fetchEstimates({ accountId: id, type: props.type, params: filters }));
        }
        // setSelectedInvoices(invoices);
        console.log("Selected Invocie from InvoiceList");
        console.log(selectedInvoices);
        console.log(estimates);
        console.log("Selected Invocie from InvoiceList END");
        setIsRefersh(true);
    }, [dispatch, selectedAccount, filters, isRefersh]);

    const actionChangeHandler =(data:any) => {
        setIsRefersh(data.isRefersh)
    }

    /** 
    * Column defs for account list data grid.
    */
    const columns: GridColDef[] = useMemo(() => {
        let gridCols = [];
        if (props.type == 'account-payable') {
            gridCols = [
                {
                    field: "invoiceNumber",
                    headerName: 'Invoice #',
                    type: "string",
                    flex: 1,
                    renderCell: ({ row, value }: GridValueGetterParams) => (
                        <Tooltip title={value}>
                            <Typography >
                                <Typography
                                    sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                                    component={Link}
                                    underline='hover'
                                    onClick={() => handleInvoiceNoClick(row)}>
                                    {value}
                                </Typography>
                            </Typography>
                        </Tooltip>
                    )
                },
            ];
        } else {
            gridCols = [
                {
                    field: "estimateNumber",
                    headerName: 'Estimate #',
                    type: "string",
                    flex: 1,
                    renderCell: ({ row, value }: GridValueGetterParams) => (
                        <Typography
                            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                            component={Link}
                            underline='hover'
                            onClick={() => handleInvoiceNoClick(row)}
                        >
                            <Tooltip title={value}>
                                <Typography >
                                    {value}
                                </Typography>
                            </Tooltip>
                        </Typography>
                    )
                },

                {
                    field: "date",
                    headerName: 'Estimate Date',
                    type: "date",
                    flex: 1,
                    renderCell: ({ row, value }: GridValueGetterParams) => (
                        <>
                            <Typography >
                                {moment(value).format("DD/MM/YYYY")}
                            </Typography>

                        </>
                    )
                },
                {
                    field: "buyer",
                    headerName: 'Customer',
                    type: "string",
                    flex: 1,
                    renderCell: ({ row, value }: GridValueGetterParams) => {
                        
                        let customer = value;
                        if (props.type === 'account-receivable') {
                            if (row.invoiceAccountRelation === 'AP') {
                                // showing invoices that are created by others for the logged-in user.
                                customer = row.account;
                            }
                        }

                        return (<>
                            <Tooltip title={customer?.name}>
                                <Typography >
                                    {customer?.name}
                                </Typography>
                            </Tooltip>
                        </>)
                    }
                },
                {
                    field: "amount",
                    headerName: 'Total',
                    type: "string",
                    flex: 1,
                    renderHeader: (params: GridColumnHeaderParams) => (
                        <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Total</span>
                    ),
                    renderCell: ({ row, value }: GridValueGetterParams) => {
                        return (<>

                            <Typography className='flex-end' >
                                {Utils.formatNumber(parseInt(row.amount) || '0')}
                            </Typography>

                        </>);
                    }
                },
                {
                    field: "createdBy",
                    headerName: 'Created By',
                    type: "string",
                    flex: 1,
                    renderCell: ({ row }: GridValueGetterParams) => (
                        <Typography>
                            {row.createdBy?.name || '-'}
                        </Typography>
                    )
                },
                {
                    field: "status",
                    headerName: 'Status',
                    type: "string",
                    flex: 1,
                    renderCell: ({ row, value }: GridValueGetterParams) => {
                        return (<>
                            { row.status == 'DRAFT' &&
                                <ListItem>
                                    <Badge color="primary" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                                </ListItem>
                            }
                            { row.status == 'PENDING' &&
                                <ListItem>
                                    <Tooltip title={row.status} color="warning">
                                        <Badge color="warning" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                                    </Tooltip>
                                </ListItem>
                            }
                            { row.status == 'PARTIALLY_PAID' &&
                                <ListItem>
                                    <Badge color="info" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                                    
                                </ListItem>
                            }
                            { row.status == 'PAID' &&
                                <ListItem>
                                    <Badge color="success" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                                </ListItem>
                            }
                            
                        </>);
                    }
                },
                {
                    field: "action",
                    headerName: 'Action',
                    type: "string",
                    flex: 1,
                    renderCell: ({ row, value }: GridValueGetterParams) => {
                        return (
                            <CustomizedEstimateMenus type={props.type} row={row} actionChangeHandler={actionChangeHandler}/>
                        );
                    }
                }
            ];
        }

        return gridCols;
    },
        [handleInvoiceNoClick]);

    return (
        <>
            {(props.accountType == "Invoices") ? "" :
                <StyledCard>
                    <CardContent>
                        <Typography className={'cardHeader'} variant="h4" component="div">
                            <Box>Business Summary</Box>
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ 'color': '#8c8c8c', 'fontWeight': '400', 'fontSize': '14px', 'padding': '22px;' }} component="div">
                            (volume+amount with % up/down)<br />
                            Total <br />
                            This Month<br />
                            This Week
                        </Typography>
                    </CardContent>
                </StyledCard>
            }
            <StyledCard sx={{ height: 'calc(100vh - 325px)', marginTop: '-10px', marginLeft: '-8px' }}>
                <CardContent >
                    <Typography className={'cardHeader'} variant="h4" component="div">
                        <Box sx={{ display: "flex", justifyContent: "end", paddingTop: '8px', width: '100%' }}>
                            <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-start', flex: 1, alignItems: "flex-start", textAlign: "start" }}>
                                {TabHeading}
                                <Filters type={props.type} filterHandler={filterOnChangeHandler} />
                            </div>
                            {(props.accountType == "Invoices") ?
                                <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-end', clear: "both" }}>
                                    
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color='primary'
                                        onClick={handleAddEstimate}
                                        style={{ fontSize: '14px', width: '158px', height: '35px', marginLeft: '15px', alignSelf: 'right' }}
                                    >
                                        New Estimate
                                    </Button>
                                </div>
                                : ""}

                        </Box>

                        {(props.accountType == "Invoices") ? "" :
                            <div style={{ width: '100%', display: "flex", flexDirection: 'row', justifyContent: 'flex-end', clear: "both" }}>
                                <Button onClick={() => { openAccountGrid('cash'); }} variant='outlined'>Cash</Button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Button onClick={() => { openAccountGrid('electronic'); }} variant='outlined'>Electronic</Button>
                            </div>
                        }
                    </Typography>
                    <div style={{ minHeight: '400px', height: 'calc(100% - 80px)', width: '100%' }}>
                        <Drawer
                            disableEscapeKeyDown={false}
                            anchor="right"
                            onClose={handleCloseCreateEstimateDrawer}
                            open={openRecivePaymentDrawer}>
                            <EstimateForm type={'sale-estimate'} />
                        </Drawer>

                        <CustomDataGrid
                            //isRowSelectable={(params: any) =>
                            //    params.row.status != 'DRAFT' && params.row.status != 'PAID'}

                            // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                            // checkboxSelection={props.type == 'account-receivable'}
                            columns={columns}
                            rows={estimates}
                            getRowId={(row) => row._id}
                            loading={status === ApiStatus.LOADING} />
                    </div>
                </CardContent>
            </StyledCard>
        </>
    );
}
export default CashFlowData;

function openAccountGrid(accType: string) {
    //throw new Error('Function not implemented.');
    alert('Show ' + accType + ' payments');
}
